"use strict";

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClassic = isClassic;
exports.isDLS = isDLS;

var _themes = require("../../../style/themes");

function isClassic(_ref) {
  var name = _ref.name;
  return name === _themes.classicTheme.name;
}

function isDLS(_ref2) {
  var name = _ref2.name;
  return name === _themes.mintTheme.name || name === _themes.aegeanTheme.name;
}